var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t(
        "default",
        [
          _c(
            "div",
            { staticClass: "single container-max page-content theme" },
            [
              _c("div", { staticClass: "row position-relative grid-wrap" }, [
                _c(
                  "div",
                  { staticClass: "col-12 col-lg mt-5 grid-1" },
                  [
                    _vm._t("image-carousel"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "stoerer-wrapper" },
                      [
                        _vm.currentVariation.variationProperties &&
                        _vm.currentVariation.variationProperties.length
                          ? [
                              _vm._l(
                                _vm.currentVariation.variationProperties,
                                function(variationGroup) {
                                  return [
                                    _vm._l(variationGroup.properties, function(
                                      prop
                                    ) {
                                      return [
                                        prop.values && prop.values.value
                                          ? _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value:
                                                      prop.id === 12 ||
                                                      prop.id === 13 ||
                                                      prop.id === 14 ||
                                                      prop.id === 2,
                                                    expression:
                                                      "prop.id === 12 || prop.id === 13 || prop.id === 14 || prop.id === 2"
                                                  }
                                                ],
                                                key: prop.id,
                                                class: {
                                                  onlineonly: prop.id === 12,
                                                  storeonly: prop.id === 13,
                                                  temp: prop.id === 14,
                                                  ads: prop.id === 2
                                                }
                                              },
                                              [
                                                prop.id === 12
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "stabiloVueTheme::Single.OnlineOnly"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  : prop.id === 13
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "stabiloVueTheme::Single.StoreOnly"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  : prop.id === 14
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "stabiloVueTheme::Single.TempOnly"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  : prop.id === 2
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$translate(
                                                            "stabiloVueTheme::Single.AdsOnly"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e()
                                      ]
                                    })
                                  ]
                                }
                              )
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-lg mt-md-5 grid-2" }, [
                  _c(
                    "div",
                    [
                      _vm.currentVariation.variation.name.length > 0
                        ? _c(
                            "h1",
                            {
                              staticClass:
                                "h2 title font-weight-bold font-heading",
                              attrs: { "data-testing": "item-name" }
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.currentVariation.variation.name
                                  )
                                }
                              })
                            ]
                          )
                        : _c(
                            "h1",
                            {
                              staticClass:
                                "h2 title font-weight-bold font-heading"
                            },
                            [
                              _c("span", {
                                attrs: { "data-testing": "item-name" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.currentVariation.texts.name1
                                  )
                                }
                              })
                            ]
                          ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "allg-infos d-flex flex-column flex-md-row align-items-start justify-content-start justify-content-md-start align-items-md-center"
                        },
                        [
                          _vm.currentVariation.item.feedbackCount > 2
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "feedback-wrap d-flex align-items-center mb-1 mb-md-0"
                                },
                                [
                                  _c(
                                    "a",
                                    { attrs: { href: "#feedback-anchor" } },
                                    [
                                      _vm._t("before-price"),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "text-secondary feedback-count"
                                        },
                                        [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .feedbackCount
                                              ) +
                                              ")"
                                          )
                                        ]
                                      )
                                    ],
                                    2
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentVariation.item.feedbackCount > 2
                            ? _c("div", { staticClass: "d-none d-md-block" }, [
                                _vm._v(" / ")
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "articlenumber mb-1 mb-md-0" },
                            [
                              _c("span", { staticClass: "headline" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.singleItemNumber"
                                    )
                                  ) + " "
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.currentVariation.variation.number)
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-none d-md-block" }, [
                            _vm._v(" / ")
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "articlenumber mb-1 mb-md-0" },
                            [
                              _c("span", { staticClass: "headline" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "stabiloVueTheme::Single.ManuItemId"
                                    )
                                  ) + ": "
                                )
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.currentVariation.variation.model)
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "d-none d-md-block" }, [
                            _vm._v(" / ")
                          ]),
                          _vm._v(" "),
                          _vm.currentVariation.item.manufacturer &&
                          _vm.currentVariation.item.manufacturer.externalName
                            ? _c(
                                "div",
                                { staticClass: "producertag" },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        _vm.$translate(
                                          "stabiloVueTheme::Single.Brand"
                                        )
                                      ) +
                                      ":\n                "
                                  ),
                                  _vm.currentVariation.item.manufacturer.url
                                    ? _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              _vm.currentVariation.item
                                                .manufacturer.url
                                          }
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer.externalName
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    : [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.currentVariation.item
                                                .manufacturer.externalName
                                            )
                                          }
                                        })
                                      ]
                                ],
                                2
                              )
                            : _vm._e()
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "singleitem-links" },
                        [_vm._t("single-bread")],
                        2
                      ),
                      _vm._v(" "),
                      _vm.attributes.length || Object.keys(_vm.units).length
                        ? _c(
                            "div",
                            { staticClass: "mb-3" },
                            [_c("variation-select")],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentVariation.variation.bundleType === "bundle"
                        ? _c("item-bundle", {
                            attrs: {
                              "bundle-type":
                                _vm.currentVariation.variation.bundleType,
                              "bundle-components":
                                _vm.currentVariation.bundleComponents
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentVariation.filter.isSalable &&
                      _vm.variationGroupedProperties.length
                        ? _c("div", [_c("order-property-list")], 1)
                        : _vm._e(),
                      _vm._v(" "),
                      _c("graduated-prices"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "d-flex price-wrap align-items-end mb-3"
                        },
                        [
                          _c("item-price", {
                            attrs: {
                              "show-cross-price": _vm.isRecommendedPriceActive,
                              "show-net-prices": _vm.showNetPrices
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._t("after-price"),
                      _vm._v(" "),
                      _vm.currentVariation.variation.availability.id <= 4
                        ? _c("span", { staticClass: "d-block translation" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$translate(
                                    "stabiloVueTheme::Single.AvailabilityID14"
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                        : _vm.currentVariation.variation.availability.id == 10
                        ? _c("span", { staticClass: "d-block translation" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$translate(
                                    "stabiloVueTheme::Single.AvailabilityID10"
                                  )
                                ) +
                                "\n            "
                            )
                          ])
                        : _c("span", { staticClass: "d-block translation" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$translate(
                                    "stabiloVueTheme::Single.AvailabilityID59"
                                  )
                                ) +
                                "\n            "
                            )
                          ]),
                      _vm._v(" "),
                      _vm.hasSpeditionDelivery
                        ? _c("div", { staticClass: "eig-availability" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "stabiloVueTheme::Single.DeliveryTimeSpedition"
                                )
                              )
                            )
                          ])
                        : _vm.currentVariation.variation.availability &&
                          _vm.currentVariation.variation.availability.names &&
                          _vm.currentVariation.variation.availability.names.name
                        ? _c("div", { staticClass: "standard-availability" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.currentVariation.variation.availability
                                    .names.name
                                ) +
                                "\n            "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentVariation.variation.availability
                        ? _c(
                            "div",
                            {
                              class:
                                "availability custom_wiederlieferbar-plugin-modal font-weight-bold availability-" +
                                _vm.currentVariation.variation.availability.id
                            },
                            [
                              _vm.currentVariation.variation.availability.id ==
                              10
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "btn btn-primary",
                                          attrs: {
                                            type: "button",
                                            "data-toggle": "modal",
                                            "data-target":
                                              "#verfuegbarkeitsModal"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$translate(
                                                  "stabiloVueTheme::Single.NotifyOnAvailability"
                                                )
                                              ) +
                                              "\n                "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm._t("verfuegbarkeits-modal")
                                    ],
                                    2
                                  )
                                : _vm._e()
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.currentVariation.variationProperties &&
                      _vm.currentVariation.variationProperties.length
                        ? [
                            _vm._l(
                              _vm.currentVariation.variationProperties,
                              function(variationGroup) {
                                return [
                                  _vm._l(variationGroup.properties, function(
                                    prop
                                  ) {
                                    return [
                                      prop.id === 2
                                        ? _c(
                                            "div",
                                            { staticClass: "advertism mt-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "alert alert-warning",
                                                  attrs: { role: "alert" }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "stabiloVueTheme::Single.WerbungText"
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      prop.id === 13
                                        ? [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "verfuegbarkeit_markt"
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-shopping-basket",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: {
                                                      href: "/baumaerkte/",
                                                      target: "_blank"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "stabiloVueTheme::Single.MarketAvailabilityLink"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("br"),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "stabiloVueTheme::Single.MarketAvailabilityText"
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        : _vm._e()
                                    ]
                                  })
                                ]
                              }
                            )
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "row add-wish-wrap my-4" }, [
                        _c(
                          "div",
                          { staticClass: "w-100" },
                          [_vm._t("before-add-to-basket")],
                          2
                        ),
                        _vm._v(" "),
                        _vm.currentVariation.item.itemType === "set"
                          ? _c(
                              "div",
                              { staticClass: "alert alert-info w-100" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.singleItemSetInfo"
                                      )
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "col-10 col-xl-11" },
                              [
                                _c("add-to-basket", {
                                  attrs: {
                                    "variation-id":
                                      _vm.currentVariation.variation.id,
                                    "is-salable":
                                      !!_vm.currentVariation.filter &&
                                      _vm.currentVariation.filter.isSalable,
                                    "has-children":
                                      !!_vm.currentVariation.filter &&
                                      _vm.currentVariation.filter
                                        .hasActiveChildren,
                                    "interval-quantity":
                                      _vm.currentVariation.variation
                                        .intervalOrderQuantity || 1,
                                    "minimum-quantity":
                                      _vm.currentVariation.variation
                                        .minimumOrderQuantity,
                                    "maximum-quantity":
                                      !!_vm.currentVariation.variation
                                        .maximumOrderQuantity &&
                                      _vm.currentVariation.variation
                                        .maximumOrderQuantity > 0
                                        ? _vm.currentVariation.variation
                                            .maximumOrderQuantity
                                        : null,
                                    "order-properties": _vm.currentVariation.properties.filter(
                                      function(prop) {
                                        return prop.property.isOderProperty
                                      }
                                    ),
                                    "has-order-properties":
                                      _vm.currentVariation.hasOrderProperties,
                                    "has-required-order-property":
                                      _vm.currentVariation
                                        .hasRequiredOrderProperty,
                                    "use-large-scale": false,
                                    "show-quantity": true,
                                    "item-url": _vm._f("itemURL")(
                                      _vm.currentVariation
                                    ),
                                    "is-variation-selected":
                                      _vm.isVariationSelected &&
                                      _vm.currentVariation.filter.isSalable,
                                    "has-price": _vm._f("hasItemDefaultPrice")(
                                      _vm.currentVariation
                                    )
                                  }
                                })
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _vm.isWishListEnabled
                          ? _c(
                              "div",
                              { staticClass: "col-2 col-xl-1 wish px-0" },
                              [
                                _c("add-to-wish-list", {
                                  attrs: {
                                    "variation-id":
                                      _vm.currentVariation.variation.id
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "w-100" },
                          [_vm._t("after-add-to-basket")],
                          2
                        )
                      ]),
                      _vm._v(" "),
                      _vm.energyLabelImage
                        ? _c("div", { staticClass: "energy-label my-3" }, [
                            _c("img", {
                              staticStyle: {
                                "max-width": "80px",
                                cursor: "pointer"
                              },
                              attrs: {
                                src: _vm.energyLabelImage,
                                alt: _vm.energyLabelValue
                              },
                              on: {
                                click: function($event) {
                                  _vm.showEnergyLabelModal = true
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.showEnergyLabelModal
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "modal fade show",
                                    staticStyle: {
                                      display: "block",
                                      background: "rgba(0,0,0,0.5)"
                                    },
                                    attrs: { tabindex: "-1" },
                                    on: {
                                      click: function($event) {
                                        if (
                                          $event.target !== $event.currentTarget
                                        ) {
                                          return null
                                        }
                                        _vm.showEnergyLabelModal = false
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "modal-dialog modal-lg modal-dialog-centered"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "modal-content" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "modal-header" },
                                              [
                                                _c(
                                                  "h5",
                                                  {
                                                    staticClass: "modal-title",
                                                    attrs: {
                                                      id:
                                                        "energyLabelModalLabel"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$translate(
                                                          "stabiloVueTheme::EnergyLabel.EnergyLabelModalTitle"
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass: "close",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function($event) {
                                                        _vm.showEnergyLabelModal = false
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        attrs: {
                                                          "aria-hidden": "true"
                                                        }
                                                      },
                                                      [_vm._v("×")]
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "modal-body text-center"
                                              },
                                              [
                                                _c("img", {
                                                  staticStyle: {
                                                    "max-width": "100%"
                                                  },
                                                  attrs: {
                                                    src:
                                                      _vm.energyLabelModalImage,
                                                    alt: "EnergieLabel"
                                                  }
                                                })
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isShortDescriptionActive &&
                      _vm.currentVariation.texts.shortDescription !== ""
                        ? _c("p", {
                            staticClass: "single-description",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.currentVariation.texts.shortDescription
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._t("additional-content-after-add-to-basket"),
                      _vm._v(" "),
                      _vm._t("additional-content-after-vat")
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-lg grid-4" }, [
                  _c(
                    "div",
                    {
                      staticClass: "accordion",
                      attrs: { id: "itemAccordion" }
                    },
                    [
                      _c("div", { staticClass: "card" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "card-header d-flex justify-content-between align-items-center px-0",
                            on: {
                              click: function($event) {
                                return _vm.toggleAccordion(
                                  "description",
                                  $event
                                )
                              }
                            }
                          },
                          [
                            _c("h2", { staticClass: "mb-0" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-link pl-0 font-weight-bold",
                                  attrs: { type: "button" }
                                },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid mr-2",
                                    attrs: {
                                      src: _vm.$translate(
                                        "stabiloVueTheme::Single.ProductDescriptionIcon"
                                      ),
                                      alt: _vm.$translate(
                                        "Ceres::Template.singleItemDescription"
                                      )
                                    }
                                  }),
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$translate(
                                          "Ceres::Template.singleItemDescription"
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa",
                              class:
                                _vm.activeAccordion === "description"
                                  ? "fa-minus"
                                  : "fa-plus",
                              attrs: { "aria-hidden": "true" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.activeAccordion === "description",
                                expression: "activeAccordion === 'description'"
                              }
                            ],
                            staticClass: "card-body px-0"
                          },
                          [
                            _c("div", {
                              staticClass: "my-4",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.currentVariation.texts.description
                                )
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.isTechnicalDataTabActive
                        ? _c("div", { staticClass: "card" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card-header d-flex justify-content-between align-items-center px-0",
                                on: {
                                  click: function($event) {
                                    return _vm.toggleAccordion(
                                      "technical",
                                      $event
                                    )
                                  }
                                }
                              },
                              [
                                _c("h2", { staticClass: "mb-0" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-link pl-0 font-weight-bold",
                                      attrs: { type: "button" }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "img-fluid mr-2",
                                        attrs: {
                                          src: _vm.$translate(
                                            "stabiloVueTheme::Single.techDataIcon"
                                          ),
                                          alt: _vm.$translate(
                                            "Ceres::Template.singleItemTechnicalData"
                                          )
                                        }
                                      }),
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$translate(
                                              "Ceres::Template.singleItemTechnicalData"
                                            )
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "fa",
                                  class:
                                    _vm.activeAccordion === "technical"
                                      ? "fa-minus"
                                      : "fa-plus",
                                  attrs: { "aria-hidden": "true" }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.activeAccordion === "technical",
                                    expression:
                                      "activeAccordion === 'technical'"
                                  }
                                ],
                                staticClass: "card-body px-0"
                              },
                              [
                                _c("div", {
                                  staticClass: "my-4",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.currentVariation.texts.technicalData
                                    )
                                  }
                                })
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "card" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "card-header d-flex justify-content-between align-items-center px-0",
                            on: {
                              click: function($event) {
                                return _vm.toggleAccordion(
                                  "assessments",
                                  $event
                                )
                              }
                            }
                          },
                          [
                            _c("h2", { staticClass: "mb-0" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-link pl-0 font-weight-bold",
                                  attrs: { type: "button" }
                                },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid mr-2",
                                    attrs: {
                                      src: _vm.$translate(
                                        "stabiloVueTheme::Single.moreDetailsIcon"
                                      ),
                                      alt: "weitere Details"
                                    }
                                  }),
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$translate(
                                          "stabiloVueTheme::Single.moreDetailsText"
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa",
                              class:
                                _vm.activeAccordion === "assessments"
                                  ? "fa-minus"
                                  : "fa-plus",
                              attrs: { "aria-hidden": "true" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.activeAccordion === "assessments",
                                expression: "activeAccordion === 'assessments'"
                              }
                            ],
                            staticClass: "card-body px-0"
                          },
                          [
                            _c("div", { staticClass: "my-4" }, [
                              _c(
                                "table",
                                {
                                  staticClass:
                                    "table table-striped table-hover table-sm"
                                },
                                [
                                  _c("tbody", [
                                    _vm.itemConfig.includes("item.id") ||
                                    _vm.itemConfig.includes("all")
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemId"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item.id
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.item.condition &&
                                    _vm.currentVariation.item.condition.names
                                      .name !== "" &&
                                    (_vm.itemConfig.includes(
                                      "item.condition"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemCondition"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .condition.names.name
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.itemConfig.includes(
                                      "item.age_rating"
                                    ) || _vm.itemConfig.includes("all")
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemAge"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm._f("ageRestriction")(
                                                  _vm.currentVariation.item
                                                    .ageRestriction
                                                )
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.variation
                                      .externalId !== "" &&
                                    (_vm.itemConfig.includes(
                                      "item.external_id"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemExternalVariationId"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.variation
                                                  .externalId
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.variation.model !==
                                      "" &&
                                    (_vm.itemConfig.includes(
                                      "item.variation_model"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemModel"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.variation
                                                  .model
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.filter
                                      .hasManufacturer &&
                                    _vm.currentVariation.item.manufacturer
                                      .externalName !== "" &&
                                    (_vm.itemConfig.includes(
                                      "item.manufacturer"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemManufacturer"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer.externalName
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.item
                                      .producingCountry &&
                                    _vm.currentVariation.item.producingCountry
                                      .names.name !== "" &&
                                    (_vm.itemConfig.includes(
                                      "item.producerCountry"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemManufacturingCountry"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .producingCountry.names.name
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.unit &&
                                    (_vm.itemConfig.includes(
                                      "item.variationBase_content"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemContent"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.unit
                                                  .content
                                              ) +
                                                " " +
                                                _vm._s(
                                                  _vm.currentVariation.unit
                                                    .names.name
                                                )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.variation.weightG !==
                                      "" &&
                                    (_vm.itemConfig.includes("item.weightG") ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemWeight"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.variation
                                                  .weightG
                                              ) + " g"
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.variation
                                      .weightNetG !== "" &&
                                    (_vm.itemConfig.includes(
                                      "item.weightNetG"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemNetWeight"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.variation
                                                  .weightNetG
                                              ) + " g"
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.itemConfig.includes(
                                      "item.variation_dimensions"
                                    ) || _vm.itemConfig.includes("all")
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemDimensions"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .lengthMM
                                                )
                                              )
                                            ]),
                                            _vm._v("×"),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .widthMM
                                                )
                                              )
                                            ]),
                                            _vm._v("×"),
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.currentVariation.variation
                                                    .heightMM
                                                )
                                              )
                                            ]),
                                            _vm._v(
                                              " mm\n                        "
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.currentVariation.variation
                                      .customsTariffNumber !== "" &&
                                    (_vm.itemConfig.includes(
                                      "variation.customs_tariff_number"
                                    ) ||
                                      _vm.itemConfig.includes("all"))
                                      ? _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$translate(
                                                  "Ceres::Template.singleItemCustomsTariffNumber"
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentVariation.variation
                                                  .customsTariffNumber
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e()
                                  ])
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "singleitem-produktdatenblatt" },
                              [
                                _vm._l(
                                  _vm.currentVariation.variationProperties,
                                  function(variationGroups) {
                                    return [
                                      _vm._l(
                                        variationGroups.properties,
                                        function(variationProperty) {
                                          return [
                                            variationProperty.id === 44 &&
                                            variationProperty.values &&
                                            variationProperty.values.value
                                              ? _c("a", {
                                                  staticClass:
                                                    "text-dark mb-2 d-block",
                                                  attrs: {
                                                    href:
                                                      variationProperty.values
                                                        .value,
                                                    target: "_blank"
                                                  },
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$translate(
                                                        "stabiloVueTheme::Single.ProductDataSheet"
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        }
                                      )
                                    ]
                                  }
                                )
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "singleitem-produktdatenblatt" },
                              [
                                _vm._l(
                                  _vm.currentVariation.variationProperties,
                                  function(variationGroups) {
                                    return [
                                      _vm._l(
                                        variationGroups.properties,
                                        function(variationProperty) {
                                          return [
                                            variationProperty.id === 143 &&
                                            variationProperty.values &&
                                            variationProperty.values.value
                                              ? _c("a", {
                                                  staticClass:
                                                    "text-dark mb-2 d-block",
                                                  attrs: {
                                                    href:
                                                      variationProperty.values
                                                        .value,
                                                    target: "_blank"
                                                  },
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$translate(
                                                        "stabiloVueTheme::Single.Manual"
                                                      )
                                                    )
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        }
                                      )
                                    ]
                                  }
                                )
                              ],
                              2
                            )
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _vm.isManufacturerTabShown
                        ? _c("div", { staticClass: "card" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "card-header d-flex justify-content-between align-items-center px-0",
                                on: {
                                  click: function($event) {
                                    return _vm.toggleAccordion(
                                      "manufacturer",
                                      $event
                                    )
                                  }
                                }
                              },
                              [
                                _c("h2", { staticClass: "mb-0" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-link pl-0 font-weight-bold",
                                      attrs: { type: "button" }
                                    },
                                    [
                                      _c("img", {
                                        staticClass: "img-fluid mr-2",
                                        attrs: {
                                          src: _vm.$translate(
                                            "stabiloVueTheme::Single.EuResponsibleIcon"
                                          ),
                                          alt: _vm.$translate(
                                            "Ceres::Template.singleItemManufacturer"
                                          )
                                        }
                                      }),
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(
                                            _vm.$translate(
                                              "stabiloVueTheme::Single.EuResponsibleHeadline"
                                            )
                                          ) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "fa",
                                  class:
                                    _vm.activeAccordion === "manufacturer"
                                      ? "fa-minus"
                                      : "fa-plus",
                                  attrs: { "aria-hidden": "true" }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.activeAccordion === "manufacturer",
                                    expression:
                                      "activeAccordion === 'manufacturer'"
                                  }
                                ],
                                staticClass: "card-body px-0"
                              },
                              [
                                _c("div", { staticClass: "my-4" }, [
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .name
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .legalName
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .street
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .houseNo
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .postcode
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .town
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.currentVariation.item.manufacturer
                                      .countryObject
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer.countryObject
                                                  .name
                                              ) +
                                              "\n                    "
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .email
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .url
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .phoneNumber
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .faxNumber
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .contactUrl
                                        )
                                      )
                                    ])
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "mb-4" }, [
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleName
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleStreet
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleHouseNo
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsiblePostCode
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleTown
                                        )
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _vm.currentVariation.item.manufacturer
                                      .responsibleCountryObject
                                      ? _c("span", [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(
                                                _vm.currentVariation.item
                                                  .manufacturer
                                                  .responsibleCountryObject.name
                                              ) +
                                              "\n                    "
                                          )
                                        ])
                                      : _vm._e()
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleEmail
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsiblePhoneNo
                                        )
                                      )
                                    ])
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "p-0" }, [
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.currentVariation.item.manufacturer
                                            .responsibleContactUrl
                                        )
                                      )
                                    ])
                                  ])
                                ])
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "card" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "card-header d-flex justify-content-between align-items-center px-0",
                            attrs: { id: "feedback-anchor" },
                            on: {
                              click: function($event) {
                                return _vm.toggleAccordion("feedback", $event)
                              }
                            }
                          },
                          [
                            _c("h2", { staticClass: "mb-0" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-link pl-0 font-weight-bold",
                                  attrs: { type: "button" }
                                },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid mr-2",
                                    attrs: {
                                      src: _vm.$translate(
                                        "stabiloVueTheme::Single.FeedbackIcon"
                                      ),
                                      alt: "Feedback"
                                    }
                                  }),
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$translate(
                                          "stabiloVueTheme::Single.FeedbackHeadline"
                                        )
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ]),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa",
                              class:
                                _vm.activeAccordion === "feedback"
                                  ? "fa-minus"
                                  : "fa-plus",
                              attrs: { "aria-hidden": "true" }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.activeAccordion === "feedback",
                                expression: "activeAccordion === 'feedback'"
                              }
                            ],
                            staticClass: "card-body px-0"
                          },
                          [
                            _c("feedback-container", {
                              staticClass: "discuss",
                              attrs: {
                                options: {
                                  allowFeedbacksOnlyIfPurchased: false,
                                  allowNoRatingFeedback: true,
                                  feedbacksPerPage: 10,
                                  numberOfFeedbacks: 1,
                                  timestampVisibility: true,
                                  allowGuestFeedbacks: true
                                },
                                classes: "",
                                styles: ""
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _vm._t("add-detail-tabs-content")
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-lg grid-3 mt-3" }, [
                  _c(
                    "div",
                    { staticClass: "fs-xselling" },
                    [_vm._t("cross-selling-accessory")],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-12 mb-5 mb-md-0 d-flex align-items-center flex-wrap p-3 p-md-5 service"
                    },
                    [
                      _c("div", [
                        _c("p", {
                          staticClass: "h3 font-weight-bold font-heading mb-3",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$translate(
                                "stabiloVueTheme::Homepage.Section15Headline"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("p", {
                          staticClass: "mb-3 mb-md-5 h4",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$translate(
                                "stabiloVueTheme::Homepage.Section15Description"
                              )
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "d-flex flex-column flex-lg-row flex-wrap justify-content-center justify-content-md-start mb-md-5 mb-lg-0"
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "btn btn-custom d-flex align-items-center justify-content-center font-weight-bold",
                                attrs: {
                                  href: _vm.$translate(
                                    "stabiloVueTheme::Homepage.Section15Link"
                                  )
                                }
                              },
                              [
                                _c("span", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$translate(
                                        "stabiloVueTheme::Homepage.Section15LinkText"
                                      )
                                    )
                                  }
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "mt-3 mt-lg-0 ml-lg-3 contact-info"
                              },
                              [
                                _c("p", {
                                  staticClass: "mb-0 times",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$translate(
                                        "stabiloVueTheme::Homepage.Section15OpeningTimes"
                                      )
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("p", {
                                  staticClass: "mb-0 font-weight-bold phone",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$translate(
                                        "stabiloVueTheme::Homepage.Section15Phone"
                                      )
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("p", {
                                  staticClass: "mb-0 font-weight-bold email",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$translate(
                                        "stabiloVueTheme::Homepage.Section15Email"
                                      )
                                    )
                                  }
                                })
                              ]
                            )
                          ]
                        )
                      ])
                    ]
                  )
                ])
              ]),
              _vm._v(" "),
              _vm._t("feedback-container")
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { staticClass: "single container-fluid" }, [
            _c(
              "div",
              {
                ref: "stickyNav",
                staticClass:
                  "sticky-nav bg-white d-none d-xl-flex justify-content-between align-items-center",
                class: { "is-sticky": _vm.isSticky }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "container-max d-flex align-items-center justify-content-between"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "h4 font-weight-bold mb-0 px-0 py-3",
                        class: { active: _vm.activeSection === "similar" },
                        on: {
                          click: function($event) {
                            return _vm.scrollToSection("similar")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "stabiloVueTheme::Single.LastSeenHeadline"
                            )
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "h4 font-weight-bold mb-0 px-0 py-3",
                        class: { active: _vm.activeSection === "service" },
                        on: {
                          click: function($event) {
                            return _vm.scrollToSection("service")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "stabiloVueTheme::Single.ServiceHeadline"
                            )
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "h4 font-weight-bold mb-0 px-0 py-3",
                        class: {
                          active: _vm.activeSection === "recommendation"
                        },
                        on: {
                          click: function($event) {
                            return _vm.scrollToSection("recommendation")
                          }
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "stabiloVueTheme::Single.RecommendationHeadline"
                            )
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.searchTerms && _vm.searchTerms.length > 0
                      ? _c(
                          "span",
                          {
                            staticClass: "h4 font-weight-bold mb-0 px-0 py-3",
                            class: { active: _vm.activeSection === "search" },
                            on: {
                              click: function($event) {
                                return _vm.scrollToSection("search")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$translate(
                                  "stabiloVueTheme::Single.SearchHeadline"
                                )
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "sticky-price" },
                      [
                        _c("item-price", {
                          attrs: {
                            "show-cross-price": _vm.isRecommendedPriceActive
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("add-to-basket", {
                      attrs: {
                        "variation-id": _vm.currentVariation.variation.id,
                        "is-salable":
                          !!_vm.currentVariation.filter &&
                          _vm.currentVariation.filter.isSalable,
                        "has-children":
                          !!_vm.currentVariation.filter &&
                          _vm.currentVariation.filter.hasActiveChildren,
                        "interval-quantity":
                          _vm.currentVariation.variation
                            .intervalOrderQuantity || 1,
                        "minimum-quantity":
                          _vm.currentVariation.variation.minimumOrderQuantity,
                        "maximum-quantity":
                          !!_vm.currentVariation.variation
                            .maximumOrderQuantity &&
                          _vm.currentVariation.variation.maximumOrderQuantity >
                            0
                            ? _vm.currentVariation.variation
                                .maximumOrderQuantity
                            : null,
                        "order-properties": _vm.currentVariation.properties.filter(
                          function(prop) {
                            return prop.property.isOderProperty
                          }
                        ),
                        "has-order-properties":
                          _vm.currentVariation.hasOrderProperties,
                        "has-required-order-property":
                          _vm.currentVariation.hasRequiredOrderProperty,
                        "use-large-scale": false,
                        "show-quantity": true,
                        "item-url": _vm._f("itemURL")(_vm.currentVariation),
                        "is-variation-selected":
                          _vm.isVariationSelected &&
                          _vm.currentVariation.filter.isSalable,
                        "has-price": _vm._f("hasItemDefaultPrice")(
                          _vm.currentVariation
                        )
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "container-max mt-5" }, [
              _c("div", { staticClass: "row position-relative" }, [
                _c("div", { staticClass: "col-12 mb-5" }, [
                  _c(
                    "div",
                    { staticClass: "fs-xselling similar" },
                    [
                      _c(
                        "p",
                        {
                          staticClass:
                            "h3 title font-weight-bold font-heading mb-3"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "stabiloVueTheme::Single.LastSeenHeadline"
                              )
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm._t("item-list-container"),
                      _vm._v(" "),
                      _vm._t("cross-selling-similar")
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 mb-5" }, [
                  _c("div", { staticClass: "row service-finder" }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "col-12 h3 title font-weight-bold font-heading mb-3"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$translate(
                              "stabiloVueTheme::Single.ServiceHeadline"
                            )
                          )
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-md-6 mb-5 mb-md-0 d-flex align-items-center flex-wrap"
                      },
                      [
                        _c("div", { staticClass: "p-3 p-md-5 service" }, [
                          _c("p", {
                            staticClass:
                              "h3 font-weight-bold font-heading mb-3",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$translate(
                                  "stabiloVueTheme::Homepage.Section15Headline"
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "mb-3 mb-md-5 h4",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$translate(
                                  "stabiloVueTheme::Homepage.Section15Description"
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column flex-lg-row flex-wrap justify-content-center justify-content-md-start mb-md-5 mb-lg-0"
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-custom d-flex align-items-center justify-content-center font-weight-bold p-4",
                                  attrs: {
                                    href: _vm.$translate(
                                      "stabiloVueTheme::Homepage.Section15Link"
                                    )
                                  }
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$translate(
                                          "stabiloVueTheme::Homepage.Section15LinkText"
                                        )
                                      )
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "mt-3 mt-lg-0 ml-lg-3 contact-info"
                                },
                                [
                                  _c("p", {
                                    staticClass: "mb-0 times",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$translate(
                                          "stabiloVueTheme::Homepage.Section15OpeningTimes"
                                        )
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("p", {
                                    staticClass: "mb-0 font-weight-bold phone",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$translate(
                                          "stabiloVueTheme::Homepage.Section15Phone"
                                        )
                                      )
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("p", {
                                    staticClass: "mb-0 font-weight-bold email",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$translate(
                                          "stabiloVueTheme::Homepage.Section15Email"
                                        )
                                      )
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-md-6 mb-5 mb-md-0 d-flex flex-wrap align-items-stretch align-items-lg-center"
                      },
                      [
                        _c("div", { staticClass: "p-3 p-md-5 finder" }, [
                          _c("p", {
                            staticClass:
                              "h3 font-weight-bold font-heading mb-3 text-white",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$translate(
                                  "stabiloVueTheme::Single.FinderHeadline"
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "mb-3 mb-md-5 h4 text-white",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$translate(
                                  "stabiloVueTheme::Single.FinderDescription"
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column flex-lg-row flex-wrap justify-content-center justify-content-md-start mb-md-5 mb-lg-0"
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass:
                                    "btn btn-custom d-flex align-items-center justify-content-start font-weight-bold p-4",
                                  attrs: {
                                    href: _vm.$translate(
                                      "stabiloVueTheme::Single.FinderLink"
                                    )
                                  }
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.$translate(
                                          "stabiloVueTheme::Single.FinderLinkText"
                                        )
                                      )
                                    }
                                  })
                                ]
                              )
                            ]
                          )
                        ])
                      ]
                    )
                  ])
                ]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _vm.searchTerms && _vm.searchTerms.length > 0
                  ? _c("div", { staticClass: "col-12 mb-5" }, [
                      _c(
                        "div",
                        { staticClass: "row search-sugg" },
                        [
                          _c(
                            "p",
                            {
                              staticClass:
                                "h3 title font-weight-bold font-heading w-100 mb-3"
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$translate(
                                    "stabiloVueTheme::Single.SearchHeadline"
                                  )
                                )
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.searchTerms, function(search, idx) {
                            return [
                              _c(
                                "a",
                                {
                                  key: idx,
                                  class:
                                    "px-3 py-1 mb-3" +
                                    (idx < _vm.searchTerms.length - 1
                                      ? " mr-3"
                                      : ""),
                                  attrs: {
                                    href: "/search/?query=" + search.trim()
                                  }
                                },
                                [_vm._v(_vm._s(search.trim()))]
                              )
                            ]
                          })
                        ],
                        2
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 mb-5" }, [
                  _c("div", { staticClass: "row newsletter p-3" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 col-md-6 mb-3 mb-md-0 d-flex align-items-center flex-wrap"
                      },
                      [
                        _c("div", [
                          _c("p", {
                            staticClass:
                              "h3 font-weight-bold font-heading mb-3",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$translate(
                                  "stabiloVueTheme::Homepage.Section13NewsletterHeadline"
                                )
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("p", {
                            staticClass: "mb-0",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$translate(
                                  "stabiloVueTheme::Homepage.Section13NewsletterDescription"
                                )
                              )
                            }
                          })
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-12 col-md-6 mb-3 mb-md-0" }, [
                      _c(
                        "form",
                        {
                          staticClass: "layout_form cr_form cr_font mb-3",
                          attrs: {
                            action:
                              "https://mailings.stabilo-fachmarkt.de/f/47330-72007/wcs/",
                            method: "post",
                            target: "_blank"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "cr_body cr_page cr_font formbox" },
                            [
                              _c("div", { staticClass: "non_sortable" }),
                              _vm._v(" "),
                              _c("div", { staticClass: "editable_content" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "cr_ipe_item ui-sortable musthave",
                                    attrs: { id: "1605817", rel: "email" }
                                  },
                                  [
                                    _vm._m(2),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "d-flex align-items-start"
                                        },
                                        [
                                          _c("input", {
                                            staticClass: "mt-1",
                                            attrs: {
                                              type: "checkbox",
                                              name: "chbox",
                                              id: "chbox",
                                              required: ""
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("span", {
                                            staticClass: "text-dark ml-2",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$translate(
                                                  "stabiloVueTheme::Homepage.Section13NewsletterLegal"
                                                )
                                              )
                                            }
                                          })
                                        ]
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 client" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 px-3 px-md-0 d-block" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "h3 title font-weight-bold font-heading w-100 mb-3"
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "stabiloVueTheme::Homepage.Section9Headline"
                              )
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-12 swiper myBadgeSwiper mb-3 px-0" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "swiper-wrapper d-flex justify-content-between"
                          },
                          [
                            _vm._l(5, function(i) {
                              return [
                                _vm.$translate(
                                  "stabiloVueTheme::Homepage.Section9Trust" +
                                    i +
                                    "Img"
                                )
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          key: i,
                                          staticClass:
                                            "swiper-slide d-flex badge position-relative pt-3 justify-content-center mr-md-3"
                                        },
                                        [
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "trust d-flex align-items-center justify-content-center w-100",
                                              attrs: {
                                                href: _vm.$translate(
                                                  "stabiloVueTheme::Homepage.Section9Trust" +
                                                    i +
                                                    "Link"
                                                ),
                                                target: "_blank"
                                              }
                                            },
                                            [
                                              _c("div", {
                                                staticClass: "gradient-overlay"
                                              }),
                                              _vm._v(" "),
                                              _c("img", {
                                                staticClass: "img-fluid",
                                                attrs: {
                                                  src: _vm.$translate(
                                                    "stabiloVueTheme::Homepage.Section9Trust" +
                                                      i +
                                                      "Img"
                                                  ),
                                                  alt: _vm.$translate(
                                                    "stabiloVueTheme::Homepage.Section9Trust" +
                                                      i +
                                                      "Heading"
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "wrap font-weight-bold h3 text-dark text-center font-heading"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$translate(
                                                        "stabiloVueTheme::Homepage.Section9Trust" +
                                                          i +
                                                          "Heading"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  : _vm._e()
                              ]
                            })
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "swiper-pagination d-md-none"
                        })
                      ]
                    )
                  ])
                ])
              ])
            ])
          ])
        ],
        {
          getDataField: _vm.getDataField,
          getFilteredDataField: _vm.getFilteredDataField
        }
      )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 mb-5" }, [
      _c("div", { staticClass: "row recommendation" }, [
        _c("div", {
          staticClass: "nosto_element",
          attrs: { id: "frontpage-nosto-1" }
        })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 recommendation-6" }, [
      _c("div", {
        staticClass: "nosto_element",
        attrs: {
          id: "productpage-nosto-6",
          "data-nosto-ref": '{"ref":"productpage-nosto-6"}'
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "d-flex flex-column flex-lg-row align-items-center justify-content-start mb-3"
      },
      [
        _c("input", {
          staticClass: "input px-3 py-2",
          attrs: {
            id: "text1605817",
            name: "email",
            value: "",
            type: "text",
            placeholder: "E-Mail Adresse eingeben"
          }
        }),
        _vm._v(" "),
        _c("label", { staticClass: "itemname", attrs: { for: "text1605817" } }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "cr_ipe_item ui-sortable submit_container d-inline ml-lg-3",
            attrs: { id: "3552319", rel: "button" }
          },
          [
            _c(
              "button",
              {
                staticClass:
                  "cr_button btn btn-custom d-flex align-items-center justify-content-center font-weight-bold p-4 mb-1",
                attrs: { type: "submit" }
              },
              [_vm._v("Absenden")]
            )
          ]
        )
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }